
define(
	'Tavanoteam.TavanoTeam_Anchor_Scroll_Extension.AnchorScroll'
	, [
		'Backbone',
		'jQuery'
	]
	, function (
		Backbone,
		jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var layout = container.getComponent('Layout');
				var environment = container.getComponent("Environment");

				var scrollOffset = environment.getConfig('tavanoTeamAnchorScroll.offset');
				var scrollSpeed = 500;

				var isLocal = function () {
					return (window.location.href.indexOf("-local.ssp") != -1);
				};

				/* Scroll Function */
				var scrollToAnchor = function (anchor) {
					if (jQuery(anchor).length > 0) {
						jQuery('html, body').animate({ scrollTop: jQuery(anchor).offset().top - scrollOffset }, scrollSpeed);
					}
				};

				var clickAnchor = function (event) {
					var linkAnchor = "#" + jQuery(event.currentTarget).attr("data-anchor");

					scrollToAnchor(linkAnchor);

					if (!isLocal()) {
						window.location.href = linkAnchor;
					}
				}

				var configureAnchors = function (environment) {
					if (!!environment.application.layout.getCurrentView().inModal === false) {

						/* Load Scroll */
						if (!isLocal()) {
							var urlAnchor = window.location.hash;

							if (urlAnchor !== "" && (urlAnchor.indexOf("?") < 0) && (urlAnchor.indexOf("/") < 0) && (urlAnchor.indexOf("=") < 0)) {
								scrollToAnchor(urlAnchor);
							}
						}

						/* Click Scroll */
						jQuery("[data-anchor]").click(function (event) {
							clickAnchor(event);
						});
					}
				};

				/* Initial Elements */
				layout.on('afterShowContent', function () {
					configureAnchors(environment);
				});

				/* CMS Elements */
				if (typeof CMS !== 'undefined') {

					/* CMS Online */
					CMS.on('page:content:set', function () {
						configureAnchors(environment);
					});

				} else {

					/* CMS Local */
					Backbone.on('cms:loaded', function (cms) {
						cms.on('page:content:set', function () {
							configureAnchors(environment);
						});
					});
				}
			}
		};
	}
);
